import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import commonReducer from "./slices/CommonSlice";
import authReducer from "./slices/AuthSlice";
import { api } from "services/customBaseQuery";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["common", "auth"],
};

const rootReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  [api.reducerPath]: api.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: false,
    }).concat(api.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
